import Layout from '@/layout'

const asyncRouter = [
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    meta: { moduleName: '首页' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "Home" */ '@/views/home'),
        name: 'Home',
        meta: { moduleName: '首页', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20] }
      }
    ]
  },
  {
    path: '/equipment',
    component: Layout,
    redirect: '/equipment/index',
    meta: { moduleName: '设备管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/equipment'),
        name: 'Equipment',
        meta: { moduleName: '设备管理', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20] }
      }
    ]
  },
  {
    path: '/device',
    component: Layout,
    redirect: '/device/index',
    meta: { moduleName: '在线设备管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/device'),
        name: 'Device',
        meta: { moduleName: '在线设备管理', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20] }
      }
    ]
  },
  {
    path: '/task',
    component: Layout,
    redirect: '/task/index',
    meta: { moduleName: '任务管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "task" */ '@/views/task'),
        name: 'Task',
        // meta: { moduleName: '任务管理', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16] }
        meta: { moduleName: '任务管理', roles: [0,] }

      }
    ]
  },
  // {
  //   path: '/run',
  //   component: Layout,
  //   redirect: '/run/index',
  //   meta: { moduleName: '运行管控' },
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import(/* webpackChunkName: "run" */ '@/views/run'),
  //       name: 'Run',
  //       meta: { moduleName: '运行管控', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16] }
  //       // 所有角色都能查看
  //     }
  //   ]
  // },
  {
    path: '/model',
    component: Layout,
    redirect: '/model/index',
    meta: { moduleName: '型号管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "model" */ '@/views/model'),
        name: 'Model',
        meta: { moduleName: '型号管理', roles: [9, 10, 11, 15] }
        // 此接口只能零件厂商调用
        // 零件厂商只能将零件型号添加到自己名下
      }
    ]
  },
  {
    path: '/work',
    component: Layout,
    redirect: '/work/index',
    meta: { moduleName: '作业管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "work" */ '@/views/work'),
        name: 'Work',
        meta: { moduleName: '作业管理', roles: [0, 1, 2, 3, 5, 6, 8, 16,20] }
      }
    ]
  },
  {
    path: '/users',
    component: Layout,
    redirect: '/users/index',
    meta: { moduleName: '账号管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "Users" */ '@/views/users'),
        name: 'Users',
        meta: { moduleName: '账号管理', roles: [0,2,20] }
        // 此类接口只有管理员才能调用
      }
    ]
  },
  {
    path: '/driver',
    component: Layout,
    redirect: '/driver/index',
    meta: { moduleName: '团队管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "Driver" */ '@/views/driver'),
        name: 'Driver',
        meta: { moduleName: '团队管理', roles: [3, 5] } // 0去掉
        // 此类接口只有管理员、通航公司、设备服务商账号才能调用
      }
    ]
  },
  {
    path: '/driverApply',
    component: Layout,
    redirect: '/driverApply/index',
    meta: { moduleName: '入职管理', hideNav: true },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "DriverApply" */ '@/views/driverApply'),
        name: 'DriverApply',
        meta: { moduleName: '入职管理', roles: [0, 3, 5] }
        // 管理员、通航公司、设备服务商
      }
    ]
  },
  {
    path: '/flightLog',
    component: Layout,
    redirect: '/flightLog/index',
    meta: { moduleName: '日志管理' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "FlightLog" */ '@/views/flightLog'),
        name: 'FlightLog',
        meta: { moduleName: '日志管理', roles: [0, 3, 5, 6] }
        // meta: { moduleName: '日志管理', roles: [0, ] }
        // 管理员、通航公司、设备服务商
      }
    ]
  },
  {
    path: '/flightReplay',
    component: Layout,
    redirect: '/flightReplay/index',
    meta: { moduleName: '飞行回放' },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "flightReplay" */ '@/views/flightReplay'),
        name: 'FlightReplay',
        meta: { moduleName: '飞行回放', roles: [0, 3, 5, 6] }
        // 管理员、通航公司、设备服务商（与日志管理一致）
      }
    ]
  },
  {
    path: '/reports',
    component: Layout,
    redirect: '/reports/index',
    meta: { moduleName: '查看报表', hideNav: true},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/reports'), 
        name: 'Reports',
        meta: { moduleName: '查看报表', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,20] },
      }
    ]
  },
  {
    path: '/rtk',
    component: Layout,
    redirect: '/rtk/index',
    meta: { moduleName: 'RTK管理',},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/rtk'),
        name: 'Rtk',
        meta: { moduleName: 'rtk管理', roles: [0] },
      }
    ]
  },
  {
    path: '/rtkbase',
    component: Layout,
    redirect: '/rtkbase/index',
    meta: { moduleName: 'RTK基站管理',}, 
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/rtk/base'),
        name: 'RtkBase',
        meta: { moduleName: 'rtk基站管理', roles: [0,2] },
      }
    ]
  },
  {
    path: '/no-organization',
    component: Layout,
    redirect: '/no-organization/index',
    meta: { moduleName: '无组织页面', hideNav: true },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/no-organization'),
        name: 'NoOrganization',
        meta: { moduleName: '无组织页面', roles: [21] },
      }
    ]
  },
  {
    path: '/bom',
    component: Layout,
    redirect: '/bom/index',
    meta: { moduleName: 'bom管理',hideNav:true},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "bomUser" */ '@/views/bom'),
        name: 'BOM',
        meta: { moduleName: 'bom管理', roles: [100,99,98,97] },
      }
    ]
  },
  {
    path: '/bom/user',
    component: Layout,
    redirect: '/bom/user/index',
    meta: { moduleName: '用户管理', hideNav: true},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/bom/user'),
        name: '用户管理',
        meta: { moduleName: '用户管理', roles: [100] },
      }
    ]
  },
  {
    path: '/manu',
    component: Layout,
    redirect: '/manu/index',
    meta: { moduleName: '厂商管理'},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/manu'),
        name: '厂商',
        meta: { moduleName: '厂商管理', roles: [0,18] },
      },
      {
        path: 'snTest',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/manu/snTest/index'),
        name: '设备测试列表',
        meta: { moduleName: '设备测试列表', roles: [0,18] },
      }
    ]
  },
  {
    path: '/invoice',
    component: Layout,
    redirect: '/invoice/index',
    meta: { moduleName: '发货管理', hideNav: true},
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice'),
        name: 'Reports',
        meta: { moduleName: '发货管理', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'details',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/invoiceDetails'),
        name: 'invoiceDetails',
        meta: { moduleName: '发货单详情', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'add',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/invoiceAdd'),
        name: 'invoiceAdd',
        meta: { moduleName: '发货单添加', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'logistics/add',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/logisticsAdd'),
        name: 'logisticsAdd',
        meta: { moduleName: '发货单添加', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'logistics/order',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/logisticsOrder'),
        name: 'logisticsOrderList',
        meta: { moduleName: '订单物流列表', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'all/list',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/invoiceAll'),
        name: 'invoiceAllList',
        meta: { moduleName: '发货单全部列表', roles: [100] },
      },
      {
        path: 'logistics/all/list',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/logisticsAll'),
        name: 'logisticsAllList',
        meta: { moduleName: '物流全部列表', roles: [100] },
      },
      {
        path: 'customer',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/customer'),
        name: 'customerList',
        meta: { moduleName: '客户列表', roles: [100] },
      },
      {
        path: 'product/list',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/product/list'),
        name: 'productList',
        meta: { moduleName: '产品列表', roles: [100] },
      },
      {
        path: 'manage/order',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/invoiceManage'),
        name: 'invoiceManage',
        meta: { moduleName: '发货单关联订单', roles: [100,95,94] },
      },
      {
        path: 'manage/logistics',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/logisticsManage'),
        name: 'logisticsManage',
        meta: { moduleName: '物流单关联发货单', roles: [100,95,94] },
      },
      {
        path: 'manage/invoice_add',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/invoiceAll/invoiceAdd'),
        name: 'invoiceManageAdd',
        meta: { moduleName: '发货单添加', roles: [100,95,94] },
      },
      {
        path: 'product/machine',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/machine'),
        name: 'invoiceMachineList',
        meta: { moduleName: '成品零件列表', roles: [100,95,94] },
      },
      {
        path: 'manage/logistics_add',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/logisticsAll/logisticsAdd'),
        name: 'logisticsManageAdd',
        meta: { moduleName: '物理单添加', roles: [100,95,94] },
      },
    ]
  }, 
  {
    path: '/invoice/order',
    component: Layout,
    redirect: '/invoice/outer/orderDetails/index',
    meta: { moduleName: '订单详情', hideNav: true},
    children: [
      {
        path: 'details',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/orderDetails'),
        name: 'Reports',
        meta: { moduleName: '订单详情', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      },
      {
        path: 'add',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/invoice/outer/orderAdd'),
        name: 'Reports',
        meta: { moduleName: '订单创建', roles: [0, 100] },
      }
    ]
  },
  {
    path: '*',
    component: Layout,
    redirect: '/NotFound/index',
    meta: { moduleName: '404',hideNav: true },
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "reports" */ '@/views/NotFound'),
        name: 'Reports',
        meta: { moduleName: '404', roles: [0, 1, 2, 3, 5, 6, 8, 9, 10, 11, 12, 15, 16,100,99,98,97,96] },
      }
    ]
  }
]

export default asyncRouter
